'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@algoacademy/design-system/shared/cn';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("flex flex-col items-center gap-10 px-6 py-32 text-center sm:py-40");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <motion.h1 initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      ease: "easeOut"
    }} className={cn("bg-gradient-to-br from-contentPrimary to-algoprimary bg-clip-text font-bold text-7xl text-transparent leading-none tracking-tight sm:text-9xl")}>Algolabs</motion.h1>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <motion.p initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      delay: 0.15,
      ease: "easeOut"
    }} className="max-w-2xl font-light text-2xl text-contentSecondary leading-relaxed sm:text-3xl">Inkubator startupow edukacyjnych z AlgoAcademy</motion.p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <motion.p initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      delay: 0.3,
      ease: "easeOut"
    }} className="max-w-3xl text-contentTertiary text-lg leading-relaxed">Tworzymy aplikacje edukacyjne nowej generacji. Eksperymentujemy z AI, mentoringiem i nowymi sposobami nauki.</motion.p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className={t0}>{t1}{t2}{t3}<motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.45,
        ease: "easeOut"
      }}><Button href="/aplikacje" size="xl">Zobacz nasze aplikacje</Button></motion.div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}